module.exports = __webpack_public_path__ + "img/bdx-notifications-list-icon.4426251f.png";